export default {
	SET_USER_STATE (state, val) {
		state.userState = typeof val === 'object' && val ? val : null
	},
	SET_USER_CUSTOMER_ID (state, val) {
		state.userCustomerId = val
	},
	SET_USER_SUBSCRIPTION_ID (state, val) {
		state.userSubscriptionId = val
	},
	SET_USER_SUBSCRIPTION_SECRET (state, val) {
		state.userSubscriptionSecret = val
	},
	SET_SUBSCRIPTION_PAYMENT (state, val) {
		state.userSubscriptionPayment = val
	},
	SET_USER_PROMO_CODE (state,val) {
		state.userPromoCode = typeof val === 'string' && val ? val : ''
	},
	SET_USER_QRCODE (state, val) {
		state.userQrcode = typeof val === 'string' && val ? val : ''
	},
	SET_LOADING (state, val) {
		state.loading = val
	},
	SET_USER_AUTH (state, val) {
		if (typeof val === 'string' && val) {
			const valL = val.toLowerCase()
			if (valL === 'login' || valL === 'signup') {
				state.userAuth = valL
				return
			}
		}
		state.userAuth = null
	}
}
